import { zIndexControlsMenu } from 'crazyEditor/core/globals';
import * as Colors from 'material-ui/styles/colors';

export default {
  wrapper: {
    position: 'fixed',
    width: '150px',
    right: 0,
    bottom: 0,
    backgroundColor: Colors.grey600,
    boxShadow: '0 1px 6px rgba(0,0,0,0.12), 0 1px 4px rgba(0,0,0,0.12)',
    zIndex: zIndexControlsMenu
  },
  container: {
    userSelect: 'none',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%'
  },
  menuContainer: {
    userSelect: 'none',
    boxSizing: 'border-box',
    width: '100%',
    paddingLeft: '20px',
    paddingRight: '20px',
    marginTop: '25px'
  },
  menuTitle: {
    textAlign: 'center',
    color: Colors.grey400,
    userSelect: 'none',
    fontFamily: 'Roboto, sans-serif',
    fontSize: '14px',
    fontWeight: 'medium',
    textTransform: 'uppercase',
    paddingBottom: '5px'
  },
  menuBody: {
    width: '100%'
  },
  menuBodyList: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-start',
    paddingRight: '20px',
    paddingLeft: 0,
    boxSizing: 'border-box'
  },
  menuBodyListItem: {
    marginLeft: '-8px',
    padding: 0,
    listStyle: 'none',
  },
  menuBodyRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%'
  },
  menuBodyLabel: {
    paddingRight: '15px',
    textAlign: 'left',
    color: Colors.grey300,
    fontSize: '14px'
  },
  menuBodyInput: {
    width: '50px'
  },
  menuBodyInputDisabledUnderline: {
    borderColor: Colors.grey500
  },
  menuBodyInputDisabledInputLabel: {},
  menuBodyInputLabel: {
    color: Colors.grey300,
    textAlign: 'center',
    fontSize: '14px'
  },
  /* Menu Panel Styles */
  menuPanelTitle: {
    textAlign: 'center',
    color: Colors.grey500,
    userSelect: 'none',
    fontFamily: 'Roboto, sans-serif',
    fontSize: '14px',
    fontWeight: 'medium',
    textTransform: 'uppercase',
    paddingBottom: '5px'
  },
  menuPanelBody: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  menuPanelBodyList: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    boxSizing: 'border-box',
    padding: 0,
    listStyle: 'none',
  },
  menuPanelBodyListItem: {
    padding: 0,
    listStyle: 'none',
    display: 'inline'
  }
};
